import { useAuthContext } from '@/contexts/auth-context';

/**
 * Convenience re-export of the auth context hook.
 * Use this throughout the app to access authentication state.
 */
export const useAuth = useAuthContext;
